import { CommandBar } from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';
import {
  commandBarItems,
  farItems,
} from './invitationCommandBar/utility/getCommandBarItems';

const InvitationCommandBar = ({
  invitationSources,
  titleFilter,
  handleTitleFilterChange,
  handleInvitationSourceClick,
  handleEditInvitationClick,
}) => {
  const { t: translator } = useTranslation();

  return (
    <CommandBar
      items={commandBarItems(
        translator,
        invitationSources,
        handleInvitationSourceClick,
        handleEditInvitationClick,
      )}
      farItems={farItems(translator, titleFilter, handleTitleFilterChange)}
      ariaLabel={translator(
        'pages.createHearing.createHearingInvitations.invitationCommandBar.commandBarAriaLabel',
      )}
      styles={{
        root: {
          width: 'auto',
          backgroundColor: '#FAFAFA',
        },
      }}
    />
  );
};

export { InvitationCommandBar };
